import * as Acciones from './reduce.actions';

export interface ListasState {
    listas: any;
}

export const initialState = {
    listas: {}
};

export function reducerLista(state: ListasState = initialState, action: Acciones.actions) {
    switch (action.type) {
        case Acciones.REGISTRO_LISTA:
            return {
                ...state,
                listas: action.listas
            }
        default:
            return state;
    }
}
